<tam-dialog [opened]="dialogOpened" [dialogWidth]="800" class="container" [opened]="dialogOpened">
    <ng-template #title>
        <span class="dialog-title">{{dialogTitle}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="cancelClick()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="dialog-body" loading-spin [isLoading]="loading" [loadingSize]="'big'"
            *ngIf="autoTaggingModel && allNoteTypes">
            <div class="content" *ngIf="!loading">
                <div class="content-form">
                    <form>
                        <div class="dialog-body-field">
                            <div class="field-label">
                                <label for="modelName">Name&nbsp;
                                    <span class="required-field">*</span>
                                </label>
                            </div>
                            <input type="text" id="modelName" class="tam-textbox" name="modelName"
                                [(ngModel)]="autoTaggingModel.modelName" #modelName required>
                            <div class="field-help" [hidden]="autoTaggingModel.modelName"
                                [ngStyle]="{'color':isModelNameEmpty === false ? 'white' : '#f53249' }">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                            <div class="field-help" [hidden]="!(autoTaggingModel.modelName.length >32)"
                                [ngStyle]="{'color':isModelNameExceedMaxlength == false ? 'white' : '#f53249' }">
                                {{'general.model_name_exceed_maximum' | stringLiterals: '32'}}
                            </div>
                        </div>
                        <div class="dialog-body-field">
                            <div class="field-label">
                                <label>Entry Types&nbsp;
                                    <span class="required-field">*</span>
                                </label>
                            </div>
                            <div class="field-item">
                                <multi-sel-dropdown-filter [dropdownConfig]="dropdownConfig">
                                </multi-sel-dropdown-filter>
                            </div>
                            <div class="field-help" [hidden]="allNoteTypes"
                                [ngStyle]="{'color':isNoteTypesEmpty === false ? 'white' : '#f53249' }">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>
                        <div class="dialog-body-field">
                            <div class="field-label">
                                <label>Number of Training Notes&nbsp;
                                    <span class="required-field">*</span>
                                </label>
                            </div>
                            <div class="numerictextbox field-item" tooltipClass="tooltip-adjust-right">
                                <span class="number">
                                    <kendo-numerictextbox [format]="'n0'" [step]="100" [value]="autoTaggingModel.number"
                                        (valueChange)="changeNumber($event)">
                                    </kendo-numerictextbox>
                                </span>
                                <span class="numberTips">Enter the number of notes for each note type that Tamale should
                                    use to train its machine learning engine. We recommend at least 200.</span>
                            </div>
                            <div class="field-help" [hidden]="autoTaggingModel.number"
                                [ngStyle]="{'color':isNumberEmpty === false ? 'white' : '#f53249' }">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                            <div class="field-help" [hidden]="!isNumberExceedScope"
                                [ngStyle]="{'color':isNumberExceedScope == false ? 'white' : '#f53249' }">
                                Only number from 10 to 1000 allowed.
                            </div>
                        </div>
                        <div class="btn-gegerate">
                            <button type="submit" tam-button [tamType]="'primary'" [tamSize]="'normal'"
                                (click)="onGenerateScript()" [tamLoading]="isSaving" [disabled]="isSaving">Generate
                                Training
                                Script</button>
                        </div>
                        <div class="dialog-body-field">
                            <div class="field-script">
                                <div [innerHTML]="autoTaggingModel.script"></div>
                            </div>
                            <div class="script-tip">
                                Training the model uses CPU/Memory, so may take time. The Tamale service (JBoss) will be
                                stopped during the training process.
                            </div>
                        </div>
                    </form>
                    <div class="field-help" *ngIf="errorMsg">
                        {{errorMsg}}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
    </ng-template>
</tam-dialog>